import {
  X,
  History,
  Trash,
  Trash2,
  Minus,
  Plus,
  Info,
  Settings,
  Search,
  ChevronDown,
  CirclePlus,
  Diff,
  Loader,
  RotateCw,
  Link,
  Download,
  Funnel,
  Eye,
  EyeOff,
  Pencil,
  Archive,
  EllipsisVertical,
  Layers,
  MapPinned,
  MonitorDot,
  Bell,
  Fullscreen,
  Bolt,
  WalletMinimal,
  Equal,
  Waypoints,
  Copy,
  CalendarDays,
  CopyPlus
} from 'lucide-vue-next'

import Check from '@/components/ui/Checkbox/assets/ArrowSuccess.vue'

export const icons = {
  Close: X,
  History,
  Trash,
  Trash2,
  Minus,
  Plus,
  Info,
  Settings,
  Search,
  ChevronDown,
  CirclePlus,
  Diff,
  Loader,
  RotateCw,
  Link,
  Download,
  Funnel,
  Eye,
  EyeOff,
  Equal,
  Pencil,
  Archive,
  EllipsisVertical,
  MapPinned,
  MonitorDot,
  Bell,
  Fullscreen,
  Layers,
  Bolt,
  WalletMinimal,
  Waypoints,
  Copy,
  CalendarDays,
  Check,
  CopyPlus
}
